/* Print Phuket homepage v2 (12 Oct 2026): reveal-on-scroll, hero product stack, parallax, CTA events. */
(function () {
  if (window.__ppxHome) return; window.__ppxHome = 1;
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('ppx-js');

  // 1. Reveal on scroll
  var els = document.querySelectorAll('[data-ppx-reveal],[data-ppx-steps]');
  if (reduce || !('IntersectionObserver' in window)) {
    els.forEach(function (e) { e.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
    // Safety net: never leave content hidden (hidden tabs, odd browsers, bots that skip IO).
    var reveal = function () { els.forEach(function (e) { if (!e.classList.contains('is-in') && e.getBoundingClientRect().top < window.innerHeight * 1.2) e.classList.add('is-in'); }); };
    window.addEventListener('load', function () { setTimeout(reveal, 1200); });
    window.addEventListener('scroll', function () { clearTimeout(window.__ppxR); window.__ppxR = setTimeout(reveal, 400); }, { passive: true });
    setTimeout(function () { els.forEach(function (e) { e.classList.add('is-in'); }); }, 6000);
  }

  // 2. Hero product stack
  document.querySelectorAll('[data-ppx-stack]').forEach(function (stack) {
    var cards = [].slice.call(stack.querySelectorAll('.ppx-stack__card'));
    var dots = [].slice.call(stack.parentNode.querySelectorAll('.ppx-dot'));
    if (cards.length < 2) return;
    var i = 0, timer = null, paused = false;
    function show(n) {
      i = (n + cards.length) % cards.length;
      cards.forEach(function (c, k) {
        c.classList.toggle('is-active', k === i);
        c.classList.toggle('is-next', k === (i + 1) % cards.length);
        c.classList.toggle('is-prev', k === (i - 1 + cards.length) % cards.length);
        c.setAttribute('tabindex', k === i ? '0' : '-1');
        c.setAttribute('aria-hidden', k === i ? 'false' : 'true');
        var img = c.querySelector('img'); if (img && img.loading === 'lazy' && Math.abs(k - i) <= 1) img.loading = 'eager';
      });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function start() { if (reduce || timer) return; timer = setInterval(function () { if (!paused && !document.hidden) show(i + 1); }, 3600); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
    stack.addEventListener('mouseenter', function () { paused = true; });
    stack.addEventListener('mouseleave', function () { paused = false; });
    stack.addEventListener('focusin', function () { paused = true; });
    stack.addEventListener('focusout', function () { paused = false; });
    show(0); start();
  });

  // 3. Subtle parallax on hero colour fields (desktop, motion allowed only)
  var blobs = document.querySelectorAll('[data-ppx-parallax]');
  if (blobs.length && !reduce && window.matchMedia('(min-width: 990px)').matches) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        if (y < 1200) blobs.forEach(function (b) { b.style.transform = 'translate3d(0,' + (y * (parseFloat(b.dataset.ppxParallax) || 0.1)) + 'px,0)'; });
        ticking = false;
      });
    }, { passive: true });
  }

  // 4. CTA click events: dataLayer (GA4/GTM-ready) + Shopify customer events. Nothing is sent until a pixel is installed.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-pp-cta]'); if (!a) return;
    var payload = { cta: a.getAttribute('data-pp-cta'), label: (a.textContent || '').trim().slice(0, 60), href: a.getAttribute('href') || '' };
    window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: 'pp_cta_click' }, payload));
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('pp_cta_click', payload); } catch (err) {}
  });
})();
